(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
  // Subject dropdown → show/hide order number field + toggle required
  var subjectSelect = document.getElementById('ContactForm-subject');
  var orderWrapper  = document.getElementById('ContactForm-order-wrapper');
  var orderInput    = document.getElementById('ContactForm-order');
  if (subjectSelect && orderWrapper && orderInput) {
    subjectSelect.addEventListener('change', function () {
      var isCancellation = this.value === 'ביטול הזמנה';
      orderWrapper.style.display = isCancellation ? 'flex' : 'none';
      if (isCancellation) {
        orderInput.setAttribute('aria-required', 'true');
        orderInput.setAttribute('placeholder', 'מספר הזמנה (חובה)');
      } else {
        orderInput.removeAttribute('aria-required');
        orderInput.setAttribute('placeholder', 'מספר הזמנה (אופציונלי)');
      }
    });
  }
  // Field-specific messages, keyed by input id
  var FIELD_RULES = {
    'ContactForm-name': {
      required: 'יש להזין שם'
    },
    'ContactForm-email': {
      required: 'יש להזין כתובת דואר אלקטרוני',
      validate: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); },
      invalid: 'כתובת הדואר אלקטרוני שהוזנה אינה תקינה'
    },
    'ContactForm-phone': {
      required: 'יש להזין מספר טלפון',
      validate: function (v) { return /^[0-9\-]+$/.test(v); },
      invalid: 'מספר הטלפון אינו תקין (ספרות ומקפים בלבד)'
    },
    'ContactForm-subject': {
      required: 'יש לבחור נושא פנייה'
    },
    'ContactForm-order': {
      required: 'יש להזין מספר הזמנה לביטול'
    },
    'ContactForm-body': {
      required: 'יש להזין את תוכן ההודעה'
    }
  };

  function errorElFor(input) {
    var id = input.getAttribute('aria-describedby');
    return id ? document.getElementById(id) : null;
  }

  function getError(input) {
    var rule = FIELD_RULES[input.id];
    if (!rule) return null;
    var value = input.value.trim();
    if (input.hasAttribute('aria-required') && value === '') return rule.required;
    if (value !== '' && rule.validate && !rule.validate(value)) return rule.invalid;
    return null;
  }

  function validateField(input) {
    var errorEl = errorElFor(input);
    var msg = getError(input);
    if (msg) {
      input.classList.add('contact-form__input--error');
      input.setAttribute('aria-invalid', 'true');
      if (errorEl) errorEl.textContent = msg;
      return false;
    }
    input.classList.remove('contact-form__input--error');
    input.setAttribute('aria-invalid', 'false');
    if (errorEl) errorEl.textContent = '';
    return true;
  }

  function fields(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[aria-describedby]'));
  }

  function validateAll(form) {
    var firstInvalid = null;
    fields(form).forEach(function (input) {
      if (!validateField(input) && !firstInvalid) firstInvalid = input;
    });
    return firstInvalid;
  }

  // Errors appear ONLY on Send — block submit if anything is invalid
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('contact-form__form')) return;
    var firstInvalid = validateAll(form);
    if (firstInvalid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      firstInvalid.focus();
    }
  }, true);

  // Block the click on Send too (catches programmatic/double submit), shows all errors
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.contact-form__form [type="submit"]') : null;
    if (!btn) return;
    var form = btn.form || (btn.closest ? btn.closest('form') : null);
    if (!form) return;
    var firstInvalid = validateAll(form);
    if (firstInvalid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      firstInvalid.focus();
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
